import { IServicesList } from 'models/shop/shopBookingTemplates';
import { requestHelper } from 'redux/helpers';
import { IStore } from 'redux/IStore';

export interface IApiService extends Omit<IServicesList, 'childrenBookingTemplates'> {
	childrenBookingTemplates?: string[];
}

export interface IVariantGroups {
	item1: string;
	item2: IApiService[];
}

// pass variantParentId for updating
export function saveGroupedBookingTemplate(
	getState: () => IStore,
	services: IApiService[],
	shopId: string,
	variantParentId?: string,
) {
	const url = variantParentId
		? 'api/Shop/' + shopId + '/BookingTemplateVariants/' + variantParentId
		: 'api/Shop/' + shopId + '/BookingTemplateVariants';
	return requestHelper(
		fetch(
			getState().fetchDefault.baseAPI + url,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(services),
			}),
		),
		'location',
	);
}

export function saveMultipleGroupedBookingTemplate(
	getState: () => IStore,
	shopId: string,
	variantGroups: IVariantGroups[],
) {
	return requestHelper(
		fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + shopId + '/BookingTemplateVariantGroups',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(variantGroups),
			}),
		),
	);
}

export function updateBookingTemplate(getState: () => IStore, services: IApiService, bookingTemplateId: string) {
	return requestHelper(
		fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/BookingTemplates/' + bookingTemplateId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(services),
			}),
		),
	);
}

export function deleteBookingTemplate(getState: () => IStore, templateId: string): Promise<any> {
	if (!templateId) {
		return Promise.reject('templateId missing');
	}
	return requestHelper(
		fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/BookingTemplates/' + templateId,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		),
	);
}
